import React from 'react'

export const OnboardingText9 = () => {
    return (
        <>
            <div>Now it is time for you, initiate in the mysteries of keres, to further the goals of our order. Let them breathe through you, let their will infuse your mind with the power to
                lord over this realm.</div>

            <div>Ave IXA KERES!</div>
        </>
    )
}